"use client";

import React from "react";
import { ArrowLeft, ShoppingCart } from "lucide-react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CartContent() {
  return <section data-section-id="224200" id="cart-content" className="bg-background text-foreground py-20 px-4 md:px-8 min-h-[80vh] flex flex-col items-center relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary-foreground/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="w-full max-w-7xl mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 z-10">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/5 border border-primary/20 rounded-sm">
            <ShoppingCart className="w-6 h-6 text-primary" />
          </div>
          <h1 className="text-3xl md:text-4xl font-default font-bold text-primary tracking-tight uppercase">
            Vaša košarica
          </h1>
        </div>
        <Button variant="outline" asChild className="border-primary/20 text-primary hover:bg-primary/5 hover:text-primary backdrop-blur-sm rounded-sm">
          <Link to="#">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Povratak u trgovinu
          </Link>
        </Button>
      </div>

      <div className="w-full max-w-7xl relative z-10">
        {}
        <div className="rounded-sm border border-border bg-card/60 backdrop-blur-xl shadow-xl shadow-primary/5 p-4 md:p-8 relative">
          
          {}
          <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-primary-foreground rounded-tl-sm opacity-100 pointer-events-none"></div>
          <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-primary-foreground rounded-tr-sm opacity-100 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-primary-foreground rounded-bl-sm opacity-100 pointer-events-none"></div>
          <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-primary-foreground rounded-br-sm opacity-100 pointer-events-none"></div>

          {}
          <div className="font-default w-full [&_.wc-block-components-sidebar]:bg-secondary/50 [&_.wc-block-components-sidebar]:backdrop-blur-md [&_.wc-block-components-sidebar]:border [&_.wc-block-components-sidebar]:border-border [&_.wc-block-components-sidebar]:rounded-sm [&_.wc-block-cart__submit-button]:bg-primary-foreground [&_.wc-block-cart__submit-button]:text-primary [&_.wc-block-cart__submit-button]:font-bold [&_.wc-block-cart__submit-button]:rounded-sm [&_.wc-block-cart__submit-button]:hover:opacity-90">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}